var map = {
	"account/account.module": [
		"./src/account/account.module.ts",
		"account.module"
	],
	"app/admin/admin.module": [
		"./src/app/admin/admin.module.ts",
		"common"
	],
	"app/annuity/annuity.module": [
		"./src/app/annuity/annuity.module.ts",
		"annuity.module"
	],
	"app/event/event.module": [
		"./src/app/event/event.module.ts"
	],
	"app/financial/financial.module": [
		"./src/app/financial/financial.module.ts",
		"common",
		"financial.module"
	],
	"app/main/main.module": [
		"./src/app/main/main.module.ts",
		"common",
		"main.module"
	],
	"app/report/report.module": [
		"./src/app/report/report.module.ts",
		"common",
		"report.module"
	],
	"app/scientific-work/scientific-work.module": [
		"./src/app/scientific-work/scientific-work.module.ts",
		"scientific-work.module",
		"common"
	],
	"app/scientific/scientific.module": [
		"./src/app/scientific/scientific.module.ts",
		"scientific.module",
		"common"
	],
	"app/store/store.module": [
		"./src/app/store/store.module.ts",
		"store.module"
	],
	"congress/congress.module": [
		"./src/congress/congress.module.ts"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main